import { REVALIDATION_INTERVAL } from './constants';
import { type MegaNav } from './types';

import { CONTENTFUL_ENDPOINT } from '@/constants/endpoints';
import { isProduction } from '@/modules/env/isProduction';
import http from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';

export function fetchNavigation(id: string): Promise<MegaNav> {
  const requestBody = {
    query: `query webNavEntryQuery {
      webNav(id: "${id}", preview: ${!isProduction()}) {
        title
        itemsCollection {
          items {
            label
            colourOverride
            contentCollection {
              items {
                __typename
                ... on WebNavCategory {
                  title
                  itemsCollection {
                    items {
                      label
                      slug
                      colourOverride
                    }
                  }
                  footer {
                    label
                    slug
                    colourOverride
                  }
                }
                ... on WebNavImageLinkList {
                  title
                  itemsCollection {
                    items {
                      label
                      hideLabel
                      slug
                      imageDesktop {
                        url
                        description
                      }
                      imageMobile {
                        url
                        description
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
  };

  return (
    http
      .post(CONTENTFUL_ENDPOINT + `?id=${id}`, requestBody, {
        cache: isProduction() ? 'force-cache' : undefined,
        revalidate: isProduction() ? REVALIDATION_INTERVAL : 0,
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((res: AxiosCompatibleResponse<any>) => {
        return res.data.data.webNav.itemsCollection.items;
      })
  );
}
